import { useAlerts } from '@bw/foundry';

const validAlerts: Record<
  string,
  {
    type: Parameters<ReturnType<typeof useAlerts>['show']>[0];
    message: Parameters<ReturnType<typeof useAlerts>['show']>[1];
  }
> = {
  sessionExpired: {
    message: 'Your session has expired, please log in again.',
    type: 'error',
  },
  unknownError: {
    message: 'An unknown error has occurred.',
    type: 'error',
  },
  unassignedApplication: {
    message: 'You are not assigned to this application.',
    type: 'warning',
  },
};

export default validAlerts;
